"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "perdaxius": {
    "8385d3d8": [{
      "hkey": "a2617027",
      "slug": "perdaxius",
      "name": "Perdaxius",
      "primary": true,
      "skipSearch": false
    }],
    "bingixedda": [{
      "hkey": "a2617027",
      "slug": "perdaxius",
      "name": "Perdaxius",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "57701308": [{
      "hkey": "a2617027",
      "slug": "perdaxius",
      "name": "Perdaxius",
      "primary": true,
      "skipSearch": false
    }],
    "is-atzoris": [{
      "hkey": "a2617027",
      "slug": "perdaxius",
      "name": "Perdaxius",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d4cfbbcd": [{
      "hkey": "a2617027",
      "slug": "perdaxius",
      "name": "Perdaxius",
      "primary": true,
      "skipSearch": false
    }],
    "is-cadonis": [{
      "hkey": "a2617027",
      "slug": "perdaxius",
      "name": "Perdaxius",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;